<template>
  <span
    :class="$style.container"
    :style="containerStyles"
    role="progressbar"
    aria-valuemin="0"
    aria-valuemax="100"
  >
    <span :class="classes" />
  </span>
</template>

<script lang="ts" setup>
import { useCssModule, computed } from 'vue'
import type { BaseProps } from './types'

defineOptions({
  name: 'UiSpinner'
})

const props = withDefaults(defineProps<BaseProps>(), {
  theme: 'default',
  size: '4em'
})

const cssModule = useCssModule()

const containerStyles = computed(() => ({
  '--spinner-height-bind': 'var(--spinner-height, ' + props.size + ')'
}))

const classes = computed(() => [
  cssModule.spinner,
  cssModule['theme-' + props.theme]
])
</script>

<style lang="scss" module>
@use 'theme';

.container {
  flex-shrink: 0; // not to be affected from the outside
  height: var(--spinner-height-bind);
  display: flex;
  justify-content: center;
  align-items: center;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.spinner {
  border-radius: 50%;
  border: var(--root-spinner-border-width) solid
    var-default(--spinner-border-color);
  border-left: transparent;
  width: var(--spinner-height-bind);
  height: var(--spinner-height-bind);
  transform: translateZ(0);
  animation: spin var(--root-spinner-animation-duration) infinite linear;

  /* Theme */
  @include theme.add(secondary);
  @include theme.add(inversed);
  @include theme.add(accent);

  &.theme {
    &-current {
      border-color: currentcolor;
    }
  }
}
</style>
